export enum ExaminationErrorMessages {
    EXAMINATION_SET_FINANCIAL_REQUIREMENTS_UNMET = "EXAMINATION_SET_FINANCIAL_REQUIREMENTS_UNMET",
    COURSE_WORK_PREREQUISITES_UNMET = "COURSE_WORK_PREREQUISITES_UNMET",
    RESIT_PAYMENT_PREREQUISITE_UNMET = "RESIT_PAYMENT_PREREQUISITE_UNMET",
    RETAKE_PAYMENT_PREREQUISITE_UNMET = "RETAKE_PAYMENT_PREREQUISITE_UNMET",
    STUDENT_BLOCKED_FROM_ATTEMPTING_EXAMINATION = "STUDENT_BLOCKED_FROM_ATTEMPTING_EXAMINATION",
}